export const worldDe = {
  'world.seo.title': 'Die Welt',
  'world.seo.description':
    'Erkunde die interaktiven Karten von Grymwyrd — seine Königreiche, Ruinen und die Schauplätze der Legenden, als 2D-Kartograph und drehbarer 3D-Globus.',
  'world.heading': 'Die Welt',
  'world.intro':
    'Kartiere das ewige Zwielicht. Der Atlas ist für verschachtelte Sicht gebaut — zoome von der ganzen Welt hinab zu einem einzelnen Verlies. Vorerst ist nur die oberste Ebene interaktiv; tiefere Ebenen öffnen sich, sobald die Reiche vermessen sind.',

  'world.viewMode.label': 'Kartenansichtsmodus',
  'world.viewMode.map2d': '2D-Karte',
  'world.viewMode.globe3d': '3D-Globus',

  'world.gazetteer.navLabel': 'Orte und Schauplätze',
  'world.gazetteer.heading': 'Ortsverzeichnis',
  'world.gazetteer.sampleNotice':
    'Es werden Beispielorte gezeigt — die wahre Vermessung des Kartographen ist noch nicht verzeichnet.',
  'world.gazetteer.error': 'Das Atlas-Archiv konnte nicht erreicht werden.',

  'world.loading.atlas': 'Der Atlas wird entrollt…',
  'world.loading.globe': 'Die Welt dreht sich…',

  'world.layersActive': '{active} von {total} Ebenen aktiv.',
  'world.globeHint':
    'Ziehen zum Drehen (die Auto-Drehung pausiert, während du erkundest, und setzt nach einer Minute Untätigkeit wieder ein); scrollen zum Heranzoomen. Fahre über ein Hexfeld, um seine Kampagne zu enthüllen, klicke zum Betreten.',
  'world.webglUnavailable':
    'Der 3D-Globus benötigt WebGL, das hier nicht verfügbar ist — stattdessen wird der 2D-Atlas gezeigt.',

  'world.campaign.capitalRegion': 'Hauptstadtregion',
  'world.campaign.territory': 'Kampagnengebiet',
  'world.campaign.enter': 'Kampagne betreten',
  'world.campaign.stay': 'Im Orbit bleiben',

  'world.layers.heading': 'Kartenebenen',
  'world.layers.gmBadge': 'SL',
  'world.layers.gmRequired': 'Erfordert eine Spielleiter-Rolle.',

  'world.marker.sampleBadge': 'Beispieldaten',
  'world.marker.viewInEncyclopedia': 'In der Enzyklopädie ansehen',
  'world.marker.placeholderNote':
    'Dies ist ein Platzhalter-Ort — sobald seine Überlieferung geschrieben ist, verlinkt er zur Enzyklopädie.',

  'world.map2d.ariaLabel': 'Interaktive Oberweltkarte',
  'world.map2d.noOverworld': 'Oberwelt-Kartograph noch nicht gezeichnet — die Leere wird gezeigt',

  'world.globe.hint.enter': 'Betreten ▸',
  'world.globe.hint.open': 'Öffnen ▸',
  'world.globe.hint.claim': 'Beanspruchen ▸',
  'world.globe.uncharted': 'Unerforschte Weiten',
  'world.globe.unchartedBlurb':
    'Keine Kampagne hat dieses Hexfeld des ewigen Zwielichts beansprucht. Stecke das erste Banner.',
  'world.globe.capitalLabel': 'Grymwyrd',
}
